"use client";

import { ThemeName, EXPAND_BTN_DARK } from "./theme";
import { trackCallClicked } from "@/lib/analytics";

type ButtonSize = "base" | "lg" | "xl" | "sm";

const sizeMap: Record<ButtonSize, { text: string; minWidth: string }> = {
  sm: {
    text: "text-xs lg:text-sm 3xl:text-sm",
    minWidth: "lg:min-w-[140px] 3xl:min-w-[160px]",
  },
  base: {
    text: "text-xs lg:text-sm 3xl:text-base",
    minWidth: "lg:min-w-[170px] 3xl:min-w-[200px]",
  },
  lg: {
    text: "text-sm lg:text-base 3xl:text-lg",
    minWidth: "lg:min-w-[200px] 3xl:min-w-[230px]",
  },
  xl: {
    text: "text-sm lg:text-base 3xl:text-xl",
    minWidth: "lg:min-w-[200px] 3xl:min-w-[250px]",
  },
};

interface CallExpandBtnProps {
  variant?: "light" | "dark";
  theme?: Exclude<ThemeName, "white">;
  size?: ButtonSize;
  className?: string;
}

const CallExpandBtn = ({
  variant = "dark",
  theme = "blue",
  size = "base",
  className = "",
}: CallExpandBtnProps) => {
  const isLight = variant === "light";
  const sizeConfig = sizeMap[size as ButtonSize] || sizeMap.base;

  return (
    <a
      href="tel:+611300467513"
      className={`group inline-flex cursor-pointer items-center justify-center gap-2 rounded-lg border px-4 py-2 font-onest ${sizeConfig.text} ${sizeConfig.minWidth} font-normal transition-all duration-300 hover:gap-1 lg:gap-3 lg:rounded-xl lg:px-5 lg:py-2.5 lg:hover:gap-2 3xl:gap-5 3xl:rounded-[18px] 3xl:px-6 3xl:py-3 3xl:hover:gap-3 ${
        isLight
          ? "border-white bg-white/20 font-medium text-white backdrop-blur-sm"
          : `${EXPAND_BTN_DARK[theme]} backdrop-blur-sm`
      } ${className}`}
      onClick={() => trackCallClicked({ location: "call_expand_btn" })}
    >
      <span>Call</span>
      1300 467 513
    </a>
  );
};

export default CallExpandBtn;
